import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-smart-panel-protection-guide-ifp-shutter',
  templateUrl: './smart-panel-protection-guide-ifp-shutter.component.html',
  styleUrls: ['./smart-panel-protection-guide-ifp-shutter.component.scss']
})
export class SmartPanelProtectionGuideIfpShutterComponent implements OnInit {

  constructor(private titleService: Title, private metaService: Meta) { }

  ngOnInit(): void {
    this.titleService.setTitle("Complete Protection Guide: Dust, Impact, and Safety for Smart Panels | Virsa IFP Protection");
    this.metaService.updateTag({ name: 'description', content: 'Protect interactive smart panels from dust, impact, and damage with heavy-duty protection shutters. Complete smart panel safety guide by Virsa for classrooms and institutions.' });
  }

}
